import { network } from 'services/network';

export const ENDPOINT = 'api/bo/getTopFinishDateChanges';

export const getTopFinishDateChanges = (params) => {
    return network.post(ENDPOINT, params).then((response) => {
        return response.data;
    });
};
